import { ImSpinner3 } from "react-icons/im";

interface LoadingSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  color?: string;
}

const sizeMap = {
  sm: "text-xl",
  md: "text-2xl",
  lg: "text-3xl",
  xl: "text-4xl",
};

/**
 * Shared loading spinner component using ImSpinner3
 * Default styling matches existing usage across mangrove recommendation maps
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className = "",
  size = "xl",
  color = "text-blue-500",
}) => {
  const sizeClass = sizeMap[size];
  return <ImSpinner3 className={`animate-spin ${sizeClass} ${color} ${className}`} />;
};

export default LoadingSpinner;
